<div class="d-flex align-items-center mb-3">
  <button type="button" class="btn btn-outline-primary" (click)="returnPage()">
    <i class="fa fa-arrow-left"></i> Voltar
  </button>
  <span class="ml-2">
    {{ isConferidor ? 'Servidores para Conferência' : 'Servidores do Município' }}
    &gt; Servidor &gt; Tempo de Serviço Passado
  </span>
</div>

<div class="card tsp-page-card">
  <div class="card-body">
    <div class="tsp-page-header">
      <div class="tsp-page-heading">
        <h1 class="text-bold-400" style="color: #4e7977">
          Extrato de Tempo de Contribuição
        </h1>
        <p class="mb-2 mt-2" style="font-size: 20px; color: #363636">
          Cadastre o Extrato de Tempo de Contribuição para servidores nos
          regimes do RPPS ou INSS.
        </p>
      </div>
      <div class="tsp-header-actions" *ngIf="isConferidor">
        <label class="conferencia-check" [class.conferido]="tspConferido">
          <input
            type="checkbox"
            [(ngModel)]="tspConferido"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="salvarConferenciaLocal($event)"
          />
          Conferido?
        </label>
      </div>
    </div>
    
    <!-- Abas -->
    <ngb-tabset type="tabs" class="tempos-tabs" (tabChange)="onTabChange($event)">
      <!-- Aba Linha do Tempo -->
      <ngb-tab title="Linha do Tempo" id="tabLinhaTempo">
        <ng-template ngbTabContent>
    <div class="timeline-tab-actions">
      <button type="button" class="btn btn-primary cadastrar-tempo-btn" (click)="openModalXl(cadastroTempo, null)">
        <i class="fa fa-file-text-o mr-1"></i> Cadastrar Tempo
      </button>
    </div>
    <div class="row mt-3 tsp-summary-row">
      <div class="col-12 col-md-4">
        <div class="card card-tenpo-contribuicao tsp-summary-card">
          <div class="card-body">
            <div class="tsp-summary-heading">
              <h4 class="card-tempo-title mb-0">RPPS</h4>
              <span class="regime-indicator regime-rpps"></span>
            </div>
            <div class="tsp-summary-main">
              <strong>{{ tempoTotalRPPS }}</strong>
              <span>Dias Cadastrados</span>
            </div>
            <div class="tsp-summary-details">
              <span><b>{{ tempoTotalRPPSAverbado }}</b> averbados</span>
              <span><b>{{ tempoTotalRPPSProfessor }}</b> como professor</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="card card-tenpo-contribuicao tsp-summary-card">
          <div class="card-body">
            <div class="tsp-summary-heading">
              <h4 class="card-tempo-title mb-0">INSS</h4>
              <span class="regime-indicator regime-inss"></span>
            </div>
            <div class="tsp-summary-main">
              <strong>{{ tempoTotalINSS }}</strong>
              <span>Dias Cadastrados</span>
            </div>
            <div class="tsp-summary-details">
              <span><b>{{ tempoTotalINSSAverbado }}</b> averbados</span>
              <span><b>{{ tempoTotalINSSProfessor }}</b> como professor</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="card card-tenpo-contribuicao tsp-summary-card">
          <div class="card-body">
            <div class="tsp-summary-heading">
              <h4 class="card-tempo-title mb-0">Dias Totais</h4>
            </div>
            <div class="tsp-summary-main">
              <strong>{{ tempoTotalCadastrado }}</strong>
              <span>Dias Cadastrados</span>
            </div>
            <div class="tsp-summary-details">
              <span><b>{{ tempoTotalAverbado }}</b> averbados</span>
              <span><b>{{ tempoTotalRPPSProfessor + tempoTotalINSSProfessor }}</b> como professor</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Timeline Chart -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">Timeline de Tempo de Contribuição</h4>
              <div class="chart-filters">
                <div class="chart-filter-group" role="group" aria-label="Filtrar gráfico por regime">
                  <button 
                    type="button" 
                    class="chart-filter-btn"
                    [class.active]="filtroEixo === 'todos'"
                    (click)="aplicarFiltroEixo('todos')">
                    <i class="fa fa-bars"></i>
                    Todos
                  </button>
                  <button 
                    type="button" 
                    class="chart-filter-btn"
                    [class.active]="filtroEixo === 'rpps'"
                    (click)="aplicarFiltroEixo('rpps')">
                    <span class="regime-indicator regime-rpps"></span>
                    RPPS
                  </button>
                  <button 
                    type="button" 
                    class="chart-filter-btn"
                    [class.active]="filtroEixo === 'inss'"
                    (click)="aplicarFiltroEixo('inss')">
                    <span class="regime-indicator regime-inss"></span>
                    INSS
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div id="timelineChart" style="height: 400px;"></div>
          </div>
        </div>
      </div>
    </div>
 
    <div class="row mb-2">
      <div class="col">
        <div class="card" style="border: 1px solid #342e4914">
          <div class="card-body pr-0 pl-0 pt-0" style="border-radius: 10px">
            <table class="table text-center table-striped">
              <thead>
                <tr>
                  <th class="text-center" style="width: 50px;">
                    <div class="d-flex align-items-center justify-content-center">
                      <label class="checkbox-container" 
                             [class.checked]="selectAll"
                             [class.indeterminate]="selectedTemposCount > 0 && selectedTemposCount < tempos.length">
                        <input 
                          type="checkbox" 
                          class="select-all-checkbox"
                          [checked]="selectAll"
                          (change)="toggleSelectAll()"
                          [indeterminate]="selectedTemposCount > 0 && selectedTemposCount < tempos.length"
                        />
                      </label>
                    </div>
                  </th>
                  <th (click)="sortTable('seq')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Seq
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'seq'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'seq'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'seq'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('cnpj_cpf_empregador')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      CPF/CNPJ
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'cnpj_cpf_empregador'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'cnpj_cpf_empregador'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'cnpj_cpf_empregador'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('nome_empregrador')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Empregador
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'nome_empregrador'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'nome_empregrador'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'nome_empregrador'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('data_entrada')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Data Inicial
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'data_entrada'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'data_entrada'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'data_entrada'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('data_fim')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Data Final
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'data_fim'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'data_fim'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'data_fim'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('tempo_bruto')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Tempo Bruto (dias)
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'tempo_bruto'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'tempo_bruto'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'tempo_bruto'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('rpps_rgps')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Tipo
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'rpps_rgps'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'rpps_rgps'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'rpps_rgps'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('em_sala_de_aula')">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      Tempo em sala de aula
                      <div class="sort-icons ml-1">
                        <i
                          *ngIf="sortColumn !== 'em_sala_de_aula'"
                          class="fa fa-caret-up"
                        ></i>
                        <i
                          *ngIf="sortColumn !== 'em_sala_de_aula'"
                          class="fa fa-caret-down"
                        ></i>
                        <i
                          *ngIf="sortColumn === 'em_sala_de_aula'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': sortDirection === 'asc',
                            'fa-caret-down': sortDirection === 'desc'
                          }"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let t of tempos
                      | slice
                        : (page - 1) * pageSize
                        : (page - 1) * pageSize + pageSize;
                    let i = index
                  "
                >
                  <td class="pl-0 pr-0 text-center">
                    <label class="checkbox-container" 
                           [class.checked]="isTempoSelected(t.id)">
                      <input 
                        type="checkbox" 
                        class="tempo-checkbox"
                        [checked]="isTempoSelected(t.id)"
                        (change)="toggleSelectTempo(t.id)"
                      />
                    </label>
                  </td>
                  <td class="pl-0 pr-0">{{ t.seq }}</td>
                  <td class="pl-0 pr-0">
                    {{ formatarCpfCnpj(t.cnpj_cpf_empregador) }}
                  </td>
                  <td class="pl-0 pr-0">{{ t.nome_empregrador }}</td>
                  <td class="pl-0 pr-0">
                    {{ getBeautifulDate(t.data_entrada) }}
                  </td>
                  <td class="pl-0 pr-0">{{ getBeautifulDate(t.data_fim) }}</td>
                  <td class="pl-0 pr-0">{{ t.tempo_bruto }}</td>
                  <td class="pl-0 pr-0">
                    {{
                      t.rpps_rgps != null
                        ? t.rpps_rgps == 0
                          ? "RPPS"
                          : "INSS"
                        : ""
                    }}
                  </td>
                  <td class="pl-0 pr-0">
                    <span
                      class="badge"
                      [ngClass]="t.em_sala_de_aula == 1 ? 'badge-success' : 'badge-secondary'"
                    >
                      {{ t.em_sala_de_aula == 1 ? "Sim" : "Não" }}
                    </span>
                  </td>
                  <td class="col-2">
                    <button
                      type="button"
                      placement="top"
                      ngbTooltip="Deletar Tempo."
                      class="btn btn-outline-danger btn-icon mr-2"
                      (click)="deletarTempo(t.id)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      type="button"
                      placement="top"
                      ngbTooltip="Visualizar Tempo."
                      class="btn btn-outline-success btn-icon"
                      (click)="openModalXl(cadastroTempo, t)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- Contador de selecionados e botão de exclusão -->
          <div class="selection-panel" *ngIf="selectedTemposCount > 0">
            <div class="selection-info">
              <span class="selection-text">{{ selectedTemposCount }} Linhas Selecionadas</span>
            </div>
            <div class="selection-actions">
              <button
                type="button"
                class="btn btn-danger delete-selected-btn"
                (click)="deletarTemposSelecionados()"
              >
                <i class="fa fa-trash mr-1"></i>
                Excluir Selecionados
              </button>
            </div>
          </div>
          
          <div class="form-row d-none" style="margin: 5px">
            <div class="d-flex justify-content-center">
              <ngb-pagination
                style="margin-top: 10px"
                *ngIf="tempos.length > 0"
                [(page)]="page"
                [pageSize]="pageSize"
                [maxSize]="12"
                [collectionSize]="tempos.length"
              ></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="tempos.length == 0">
      <div class="col">
        <div class="card-content">
          <div class="card-body pl-0 pr-0">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="media">
                  <div class="media-body">
                    <h5 class="mt-0">Nenhum tempo de serviço cadastrado.</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row d-none">
      <div class="col">
        <button
          type="button"
          class="btn btn-outline-primary"
          routerLink="/page/servidor"
          [queryParams]="{ id: idServidor }"
        >
          Voltar
        </button>
      </div>
    </div>
        </ng-template>
      </ngb-tab>
      
      <!-- Aba Estatísticas do Servidor -->
      <ngb-tab title="Estatísticas do Servidor">
        <ng-template ngbTabContent>
          <div class="estatisticas-container mt-3" *ngIf="estatisticas">
            <h5 class="estatisticas-titulo">Estatísticas do Servidor</h5>
            <p class="estatisticas-descricao">Monitore o total de dias trabalhados pelo servidor para cada contrato, organizados de acordo com o tipo de regime.</p>
            
            <div class="row">
              <!-- Card Contribuição Geral -->
              <div class="col-md-4">
                <div class="card card-estatistica">
                  <div class="card-body">
                    <h6 class="card-estatistica-titulo">Contribuição Geral</h6>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Dias de Contribuição</span>
                      <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_geral.dias_totais }}</span>
                    </div>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Contratos de Trabalho</span>
                      <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_geral.total_contratos }}</span>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Distribuição por Regime</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>INSS</span>
                          <span>{{ estatisticas.contribuicao_geral.distribuicao_regime.inss.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-inss" [style.width.%]="estatisticas.contribuicao_geral.distribuicao_regime.inss.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.distribuicao_regime.inss.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>RPPS</span>
                          <span>{{ estatisticas.contribuicao_geral.distribuicao_regime.rpps.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-rpps" [style.width.%]="estatisticas.contribuicao_geral.distribuicao_regime.rpps.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.distribuicao_regime.rpps.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Distribuição por Tipo</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Magistério</span>
                          <span>{{ estatisticas.contribuicao_geral.distribuicao_tipo.magisterio.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-magisterio" [style.width.%]="estatisticas.contribuicao_geral.distribuicao_tipo.magisterio.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.distribuicao_tipo.magisterio.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Outros</span>
                          <span>{{ estatisticas.contribuicao_geral.distribuicao_tipo.outros.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-outros" [style.width.%]="estatisticas.contribuicao_geral.distribuicao_tipo.outros.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.distribuicao_tipo.outros.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Averbação</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Averbado</span>
                          <span>{{ estatisticas.contribuicao_geral.averbacao.averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-averbado" [style.width.%]="estatisticas.contribuicao_geral.averbacao.averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.averbacao.averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Não Averbado</span>
                          <span>{{ estatisticas.contribuicao_geral.averbacao.nao_averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-nao-averbado" [style.width.%]="estatisticas.contribuicao_geral.averbacao.nao_averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.averbacao.nao_averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Estatísticas de Contratos</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Longo</span>
                          <span>{{ estatisticas.contribuicao_geral.estatisticas_contratos.mais_longo.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_geral.estatisticas_contratos.mais_longo.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.estatisticas_contratos.mais_longo.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Média</span>
                          <span>{{ estatisticas.contribuicao_geral.estatisticas_contratos.media }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="(estatisticas.contribuicao_geral.estatisticas_contratos.media / estatisticas.contribuicao_geral.dias_totais * 100)"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ ((estatisticas.contribuicao_geral.estatisticas_contratos.media / estatisticas.contribuicao_geral.dias_totais) * 100) | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mediana</span>
                          <span>{{ estatisticas.contribuicao_geral.estatisticas_contratos.mediana }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="(estatisticas.contribuicao_geral.estatisticas_contratos.mediana / estatisticas.contribuicao_geral.dias_totais * 100)"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ ((estatisticas.contribuicao_geral.estatisticas_contratos.mediana / estatisticas.contribuicao_geral.dias_totais) * 100) | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Curto</span>
                          <span>{{ estatisticas.contribuicao_geral.estatisticas_contratos.mais_curto.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_geral.estatisticas_contratos.mais_curto.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_geral.estatisticas_contratos.mais_curto.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Card Contribuição no INSS -->
              <div class="col-md-4">
                <div class="card card-estatistica">
                  <div class="card-body">
                    <h6 class="card-estatistica-titulo">Contribuição no INSS</h6>
                    
                    <div class="estatistica-item estatistica-item-inline">
                      <span class="estatistica-label">Dias de Contribuição</span>
                      <div class="estatistica-valor-com-barra">
                        <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_inss.dias_totais }}</span>
                        <div class="estatistica-barra-container estatistica-barra-inline">
                          <div class="estatistica-barra estatistica-barra-inss" [style.width.%]="estatisticas.contribuicao_inss.percentual_do_total"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.percentual_do_total | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Contratos de Trabalho</span>
                      <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_inss.total_contratos }}</span>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Distribuição por Tipo</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Magistério</span>
                          <span>{{ estatisticas.contribuicao_inss.distribuicao_tipo.magisterio.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-magisterio" [style.width.%]="estatisticas.contribuicao_inss.distribuicao_tipo.magisterio.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.distribuicao_tipo.magisterio.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Outros</span>
                          <span>{{ estatisticas.contribuicao_inss.distribuicao_tipo.outros.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-outros" [style.width.%]="estatisticas.contribuicao_inss.distribuicao_tipo.outros.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.distribuicao_tipo.outros.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Averbação</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Averbado</span>
                          <span>{{ estatisticas.contribuicao_inss.averbacao.averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-averbado" [style.width.%]="estatisticas.contribuicao_inss.averbacao.averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.averbacao.averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Não Averbado</span>
                          <span>{{ estatisticas.contribuicao_inss.averbacao.nao_averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-nao-averbado" [style.width.%]="estatisticas.contribuicao_inss.averbacao.nao_averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.averbacao.nao_averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Estatísticas de Contratos</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Longo</span>
                          <span>{{ estatisticas.contribuicao_inss.estatisticas_contratos.mais_longo.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_inss.estatisticas_contratos.mais_longo.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.estatisticas_contratos.mais_longo.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Média</span>
                          <span>{{ estatisticas.contribuicao_inss.estatisticas_contratos.media }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_inss.dias_totais > 0 ? (estatisticas.contribuicao_inss.estatisticas_contratos.media / estatisticas.contribuicao_inss.dias_totais * 100) : 0"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.dias_totais > 0 ? ((estatisticas.contribuicao_inss.estatisticas_contratos.media / estatisticas.contribuicao_inss.dias_totais) * 100 | number:'1.0-0') : 0 }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mediana</span>
                          <span>{{ estatisticas.contribuicao_inss.estatisticas_contratos.mediana }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_inss.dias_totais > 0 ? (estatisticas.contribuicao_inss.estatisticas_contratos.mediana / estatisticas.contribuicao_inss.dias_totais * 100) : 0"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.dias_totais > 0 ? ((estatisticas.contribuicao_inss.estatisticas_contratos.mediana / estatisticas.contribuicao_inss.dias_totais) * 100 | number:'1.0-0') : 0 }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Curto</span>
                          <span>{{ estatisticas.contribuicao_inss.estatisticas_contratos.mais_curto.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_inss.estatisticas_contratos.mais_curto.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_inss.estatisticas_contratos.mais_curto.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Card Contribuição no RPPS -->
              <div class="col-md-4">
                <div class="card card-estatistica">
                  <div class="card-body">
                    <h6 class="card-estatistica-titulo">Contribuição no RPPS</h6>
                    
                    <div class="estatistica-item estatistica-item-inline">
                      <span class="estatistica-label">Dias de Contribuição</span>
                      <div class="estatistica-valor-com-barra">
                        <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_rpps.dias_totais }}</span>
                        <div class="estatistica-barra-container estatistica-barra-inline">
                          <div class="estatistica-barra estatistica-barra-rpps" [style.width.%]="estatisticas.contribuicao_rpps.percentual_do_total"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.percentual_do_total | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Contratos de Trabalho</span>
                      <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_rpps.total_contratos }}</span>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Distribuição por Tipo</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Magistério</span>
                          <span>{{ estatisticas.contribuicao_rpps.distribuicao_tipo.magisterio.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-magisterio" [style.width.%]="estatisticas.contribuicao_rpps.distribuicao_tipo.magisterio.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.distribuicao_tipo.magisterio.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Outros</span>
                          <span>{{ estatisticas.contribuicao_rpps.distribuicao_tipo.outros.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-outros" [style.width.%]="estatisticas.contribuicao_rpps.distribuicao_tipo.outros.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.distribuicao_tipo.outros.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Averbação</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Averbado</span>
                          <span>{{ estatisticas.contribuicao_rpps.averbacao.averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-averbado" [style.width.%]="estatisticas.contribuicao_rpps.averbacao.averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.averbacao.averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Não Averbado</span>
                          <span>{{ estatisticas.contribuicao_rpps.averbacao.nao_averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-nao-averbado" [style.width.%]="estatisticas.contribuicao_rpps.averbacao.nao_averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.averbacao.nao_averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Estatísticas de Contratos</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Longo</span>
                          <span>{{ estatisticas.contribuicao_rpps.estatisticas_contratos.mais_longo.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_rpps.estatisticas_contratos.mais_longo.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.estatisticas_contratos.mais_longo.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Média</span>
                          <span>{{ estatisticas.contribuicao_rpps.estatisticas_contratos.media }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_rpps.dias_totais > 0 ? (estatisticas.contribuicao_rpps.estatisticas_contratos.media / estatisticas.contribuicao_rpps.dias_totais * 100) : 0"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.dias_totais > 0 ? ((estatisticas.contribuicao_rpps.estatisticas_contratos.media / estatisticas.contribuicao_rpps.dias_totais) * 100 | number:'1.0-0') : 0 }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mediana</span>
                          <span>{{ estatisticas.contribuicao_rpps.estatisticas_contratos.mediana }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_rpps.dias_totais > 0 ? (estatisticas.contribuicao_rpps.estatisticas_contratos.mediana / estatisticas.contribuicao_rpps.dias_totais * 100) : 0"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.dias_totais > 0 ? ((estatisticas.contribuicao_rpps.estatisticas_contratos.mediana / estatisticas.contribuicao_rpps.dias_totais) * 100 | number:'1.0-0') : 0 }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Curto</span>
                          <span>{{ estatisticas.contribuicao_rpps.estatisticas_contratos.mais_curto.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_rpps.estatisticas_contratos.mais_curto.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_rpps.estatisticas_contratos.mais_curto.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row mt-4">
              <!-- Card Contribuição em Magistério -->
              <div class="col-md-4">
                <div class="card card-estatistica">
                  <div class="card-body">
                    <h6 class="card-estatistica-titulo">Contribuição em Magistério</h6>
                    
                    <div class="estatistica-item estatistica-item-inline">
                      <span class="estatistica-label">Dias de Contribuição</span>
                      <div class="estatistica-valor-com-barra">
                        <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_magisterio.dias_totais }}</span>
                        <div class="estatistica-barra-container estatistica-barra-inline">
                          <div class="estatistica-barra estatistica-barra-magisterio" [style.width.%]="estatisticas.contribuicao_magisterio.percentual_do_total"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.percentual_do_total | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Contratos de Trabalho</span>
                      <span class="estatistica-valor-grande">{{ estatisticas.contribuicao_magisterio.total_contratos }}</span>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Distribuição por Tipo</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Magistério</span>
                          <span>{{ estatisticas.contribuicao_magisterio.dias_totais }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-magisterio" [style.width.%]="estatisticas.contribuicao_magisterio.percentual_vs_nao_magisterio"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.percentual_vs_nao_magisterio | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Outros</span>
                          <span>{{ estatisticas.contribuicao_geral.distribuicao_tipo.outros.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-outros" [style.width.%]="100 - estatisticas.contribuicao_magisterio.percentual_vs_nao_magisterio"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ 100 - estatisticas.contribuicao_magisterio.percentual_vs_nao_magisterio | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Averbação</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Averbado</span>
                          <span>{{ estatisticas.contribuicao_magisterio.averbacao.averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-averbado" [style.width.%]="estatisticas.contribuicao_magisterio.averbacao.averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.averbacao.averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Não Averbado</span>
                          <span>{{ estatisticas.contribuicao_magisterio.averbacao.nao_averbado.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-nao-averbado" [style.width.%]="estatisticas.contribuicao_magisterio.averbacao.nao_averbado.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.averbacao.nao_averbado.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-secao">
                      <span class="estatistica-secao-titulo">Estatísticas de Contratos</span>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Longo</span>
                          <span>{{ estatisticas.contribuicao_magisterio.estatisticas_contratos.mais_longo.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_magisterio.estatisticas_contratos.mais_longo.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.estatisticas_contratos.mais_longo.percentual | number:'1.0-0' }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Média</span>
                          <span>{{ estatisticas.contribuicao_magisterio.estatisticas_contratos.media }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_magisterio.dias_totais > 0 ? (estatisticas.contribuicao_magisterio.estatisticas_contratos.media / estatisticas.contribuicao_magisterio.dias_totais * 100) : 0"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.dias_totais > 0 ? ((estatisticas.contribuicao_magisterio.estatisticas_contratos.media / estatisticas.contribuicao_magisterio.dias_totais) * 100 | number:'1.0-0') : 0 }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mediana</span>
                          <span>{{ estatisticas.contribuicao_magisterio.estatisticas_contratos.mediana }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_magisterio.dias_totais > 0 ? (estatisticas.contribuicao_magisterio.estatisticas_contratos.mediana / estatisticas.contribuicao_magisterio.dias_totais * 100) : 0"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.dias_totais > 0 ? ((estatisticas.contribuicao_magisterio.estatisticas_contratos.mediana / estatisticas.contribuicao_magisterio.dias_totais) * 100 | number:'1.0-0') : 0 }}% )</span>
                      </div>
                      <div class="estatistica-barra-item">
                        <div class="estatistica-barra-label">
                          <span>Mais Curto</span>
                          <span>{{ estatisticas.contribuicao_magisterio.estatisticas_contratos.mais_curto.dias }} d.</span>
                        </div>
                        <div class="estatistica-barra-container">
                          <div class="estatistica-barra estatistica-barra-contratos" [style.width.%]="estatisticas.contribuicao_magisterio.estatisticas_contratos.mais_curto.percentual"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ estatisticas.contribuicao_magisterio.estatisticas_contratos.mais_curto.percentual | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Card Aproveitamento Profissional -->
              <div class="col-md-4">
                <div class="card card-estatistica card-aproveitamento">
                  <div class="card-body">
                    <h6 class="card-estatistica-titulo">Aproveitamento Profissional</h6>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Dias Úteis Decorridos</span>
                      <span class="estatistica-valor-grande">{{ estatisticas.aproveitamento_profissional.dias_uteis_decorridos }}</span>
                    </div>
                    
                    <div class="estatistica-item estatistica-item-inline">
                      <span class="estatistica-label">Dias de Contribuição</span>
                      <div class="estatistica-valor-com-barra">
                        <span class="estatistica-valor-grande">{{ estatisticas.aproveitamento_profissional.dias_contribuicao }}</span>
                        <div class="estatistica-barra-container estatistica-barra-inline">
                          <div class="estatistica-barra estatistica-barra-aproveitamento" [style.width.%]="calcularPercentualContribuicao()"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ calcularPercentualContribuicao() | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-item estatistica-item-inline">
                      <span class="estatistica-label">Tempo Ocioso (Lacunas)</span>
                      <div class="estatistica-valor-com-barra">
                        <span class="estatistica-valor-grande">{{ estatisticas.aproveitamento_profissional.tempo_ocioso }}</span>
                        <div class="estatistica-barra-container estatistica-barra-inline">
                          <div class="estatistica-barra estatistica-barra-ocioso" [style.width.%]="calcularPercentualTempoOcioso()"></div>
                        </div>
                        <span class="estatistica-percentual">( {{ calcularPercentualTempoOcioso() | number:'1.0-0' }}% )</span>
                      </div>
                    </div>
                    
                    <div class="estatistica-item">
                      <span class="estatistica-label">Pct. Médio de Contribuição</span>
                      <span class="estatistica-valor-grande estatistica-valor-percentual">{{ calcularPercentualMedioContribuicao() | number:'1.0-0' }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Mensagem quando não há estatísticas -->
          <div class="row mt-3" *ngIf="!estatisticas">
            <div class="col">
              <div class="card-content">
                <div class="card-body pl-0 pr-0">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <div class="media">
                        <div class="media-body">
                          <h5 class="mt-0">Carregando estatísticas...</h5>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
    <div class="tsp-conference-footer" *ngIf="isConferidor">
      <button type="button" class="btn btn-primary" (click)="marcarConferidoEVoltar()">
        <i class="fa fa-check mr-1"></i> Marcar conferido e voltar
      </button>
    </div>
  </div>
</div>
<ng-template #edicaoCertidao let-modal>
  <div class="row mb-2">
    <div class="col">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Certidão</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <form #certidaoForm="ngForm" novalidate>
              <div class="form-row">
                <div class="col">
                  <div class="form-group">
                    <div class="controls">
                      <label for="numero_certidaoa">Certidão</label>
                      <input
                        type="text"
                        id="numero_certidaoa"
                        class="form-control"
                        [(ngModel)]="certidaoEmEdicao.numero_certidao"
                        name="numero_certidaoa"
                        placeholder="Certidão"
                        required
                        aria-invalid="false"
                      />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <div class="controls">
                      <label for="data_certidaoa">Data</label>
                      <input
                        type="text"
                        id="data_certidaoa"
                        class="form-control"
                        mask="00/00/0000"
                        [(ngModel)]="certidaoEmEdicao.data_certidao"
                        name="data_certidaoa"
                        placeholder="Data"
                        required
                        aria-invalid="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-lg btn-primary mb-2 mb-md-0 float-right"
                    (click)="atualizarCertidao(modal)"
                    [disabled]="
                      !certidaoEmEdicao.id ||
                      !certidaoEmEdicao.numero_certidao ||
                      !certidaoEmEdicao.data_certidao
                    "
                  >
                    Atualizar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cadastroTempo let-modal>
  <div class="row mb-2">
    <div class="col">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ tempo && tempo.id ? "Editar" : "Novo" }} Tempo de Contribuição
        </h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="cancelTempo(modal)">x</button>
      </div>
      <div class="modal-body">
        <form #servForm="ngForm" class="tempo-contribuicao-form" (ngSubmit)="atualizarOuCadastrar(modal)" novalidate>
          <div class="regime-toggle-block" [class.is-invalid]="erroCampoTempo('rpps_rgps')">
            <div>
              <label>Regime de Contribuição<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
              <small>Selecione onde este período de contribuição foi registrado.</small>
            </div>
            <div class="regime-toggle" role="group" aria-label="Regime de contribuição">
              <button
                type="button"
                [class.active]="tempo.rpps_rgps === 0"
                (click)="selecionarRegime(0)"
              >
                <span class="regime-indicator regime-rpps"></span> RPPS
              </button>
              <button
                type="button"
                [class.active]="tempo.rpps_rgps === 1"
                (click)="selecionarRegime(1)"
              >
                <span class="regime-indicator regime-inss"></span> INSS
              </button>
            </div>
          </div>
          <div *ngIf="erroCampoTempo('rpps_rgps')" class="invalid-feedback d-block mb-3">
            {{ erroCampoTempo("rpps_rgps") }}
          </div>
          <div class="form-row">
            <div class="col-2">
              <div class="form-group">
                <div class="controls">
                  <label for="seq" placement="top" ngbTooltip="Sequência definida automaticamente pelo sistema">Seq</label>
                  <input
                    type="number"
                    id="seq"
                    class="form-control"
                    min="1"
                    step="1"
                    [(ngModel)]="tempo.seq"
                    name="seq"
                    placeholder="Seq"
                    required
                    readonly
                    aria-invalid="false"
                  />
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="controls">
                  <label for="cnpj_cpf_empregador">CNPJ/CPF Empregador<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                  <input
                    type="text"
                    id="cnpj_cpf_empregador"
                    class="form-control"
                    [(ngModel)]="tempo.cnpj_cpf_empregador"
                    name="cnpj_cpf_empregador"
                    placeholder="CNPJ/CPF"
                    required
                    [class.is-invalid]="erroCampoTempo('cnpj_cpf_empregador')"
                    [attr.aria-invalid]="!!erroCampoTempo('cnpj_cpf_empregador')"
                    mask="000.000.000-00||00.000.000/0000-00"
                  />
                  <div *ngIf="erroCampoTempo('cnpj_cpf_empregador')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("cnpj_cpf_empregador") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <div class="controls">
                  <label for="nome_empregrador">Nome Empregador<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                  <input
                    type="text"
                    id="nome_empregrador"
                    class="form-control"
                    [(ngModel)]="tempo.nome_empregrador"
                    name="nome_empregrador"
                    placeholder="Nome"
                    required
                    [class.is-invalid]="erroCampoTempo('nome_empregrador')"
                    [attr.aria-invalid]="!!erroCampoTempo('nome_empregrador')"
                  />
                  <div *ngIf="erroCampoTempo('nome_empregrador')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("nome_empregrador") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group">
                <div class="controls">
                  <label for="data_entrada">Data Início<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                  <input
                    type="text"
                    id="data_entrada"
                    class="form-control"
                    mask="00/00/0000"
                    [(ngModel)]="tempo.data_entrada"
                    (change)="calculaTempoBruto()"
                    name="data_entrada"
                    placeholder="Data Início"
                    required
                    [class.is-invalid]="erroCampoTempo('data_entrada')"
                    [attr.aria-invalid]="!!erroCampoTempo('data_entrada')"
                  />
                  <div *ngIf="erroCampoTempo('data_entrada')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("data_entrada") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="controls">
                  <label for="data_fim">Data Fim<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                  <input
                    type="text"
                    id="data_fim"
                    class="form-control"
                    mask="00/00/0000"
                    [(ngModel)]="tempo.data_fim"
                    (change)="calculaTempoBruto()"
                    name="data_fim"
                    placeholder="Data Fim"
                    required
                    [class.is-invalid]="erroCampoTempo('data_fim')"
                    [attr.aria-invalid]="!!erroCampoTempo('data_fim')"
                  />
                  <div *ngIf="erroCampoTempo('data_fim')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("data_fim") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="controls">
                  <label for="tempo_bruto">Tempo Bruto (dias)<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                  <input
                    type="text"
                    id="tempo_bruto"
                    class="form-control"
                    [(ngModel)]="tempo.tempo_bruto"
                    name="tempo_bruto"
                    placeholder="Tempo Bruto (dias)"
                    required
                    [class.is-invalid]="erroCampoTempo('tempo_bruto')"
                    [attr.aria-invalid]="!!erroCampoTempo('tempo_bruto')"
                  />
                  <div *ngIf="erroCampoTempo('tempo_bruto')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("tempo_bruto") }}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group">
                <div class="controls">
                  <label for="averbado">Averbação<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                  <ng-select
                    [items]="averbado"
                    name="averbado"
                    bindLabel="name"
                    placeholder="Averbado"
                    bindValue="id"
                    id="averbado"
                    [(ngModel)]="tempo.averbado"
                    [clearable]="false"
                    [class.is-invalid]="erroCampoTempo('averbado')"
                  ></ng-select>
                  <div *ngIf="erroCampoTempo('averbado')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("averbado") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="controls">
                  <label for="em_sala_de_aula">Tempo em sala de aula<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>

                  <ng-select
                    [items]="emSalaDeAula"
                    name="em_sala_de_aula"
                    bindLabel="name"
                    placeholder="Em sala de aula"
                    bindValue="id"
                    id="em_sala_de_aula"
                    [(ngModel)]="tempo.em_sala_de_aula"
                    required
                    [clearable]="false"
                    [class.is-invalid]="erroCampoTempo('em_sala_de_aula')"
                  ></ng-select>
                  <div *ngIf="erroCampoTempo('em_sala_de_aula')" class="invalid-feedback d-block">
                    {{ erroCampoTempo("em_sala_de_aula") }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="contratos-atuais">
            <div class="contratos-atuais-titulo">
              <h5>Contratos Atuais</h5>
              <span>{{ tempos.length }} {{ tempos.length === 1 ? "registro" : "registros" }}</span>
            </div>
            <div class="contratos-atuais-tabela" *ngIf="tempos.length; else semContratosAtuais">
              <table class="table table-striped table-sm mb-0">
                <thead>
                  <tr>
                    <th>Seq</th>
                    <th>Data inicial</th>
                    <th>Data final</th>
                    <th>Dias</th>
                    <th>Tipo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let contrato of tempos">
                    <td>{{ contrato.seq || "—" }}</td>
                    <td>{{ getBeautifulDate(contrato.data_entrada) }}</td>
                    <td>{{ getBeautifulDate(contrato.data_fim) }}</td>
                    <td>{{ contrato.tempo_bruto || 0 }}</td>
                    <td>
                      <span class="contrato-regime">
                        <span class="regime-indicator" [ngClass]="contrato.rpps_rgps == 0 ? 'regime-rpps' : 'regime-inss'"></span>
                        {{ contrato.rpps_rgps == 0 ? "RPPS" : "INSS" }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #semContratosAtuais>
              <div class="contratos-atuais-vazio">Nenhum tempo de contribuição cadastrado.</div>
            </ng-template>
          </div>
          <div class="form-row modal-acoes-tempo">
            <div class="col">
              <button
                type="button"
                class="btn btn-outline-primary mb-md-0 float-left"
                (click)="cancelTempo(modal)"               
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="btn btn-primary mb-md-0 float-right"
                [disabled]="salvandoTempo"
              >
                {{ salvandoTempo ? "Salvando..." : (tempo.id ? "Atualizar" : "Cadastrar") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<!-- Modal de confirmação de exclusão -->
<ng-template #confirmDeleteModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Excluir Itens</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="confirmation-message">
      Deseja confirmar a exclusão desses itens?<br>
      Essa ação não poderá ser revertida.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-confirm" (click)="confirmarExclusao(modal)">
      <i class="fa fa-trash mr-1"></i>
      Confirmar
    </button>
    <button type="button" class="btn btn-cancel" (click)="modal.dismiss('Cancel click')">
      Voltar
    </button>
  </div>
</ng-template>

<ngx-spinner></ngx-spinner>
